import { D as h } from "./dialog-ByNwXkEL.js";
import { T as m } from "./events-CnaEWcY_.js";
import { d as p, f as u } from "./utilities-D-QcnR4L.js";
import "./component-B88NZlIm.js";
class f extends h {
  #t = null;
  #e = null;
  connectedCallback() {
    if (
      (super.connectedCallback(),
      document.addEventListener("liquid-ajax-cart:request-start", this.#n, { signal: this.signal }),
      document.addEventListener("pointerdown", this.#s, { signal: this.signal }),
      document.addEventListener("liquid-ajax-cart:request-end", this.#a, { signal: this.signal }),
      document.addEventListener(m.cartUpdate, this.#o, { signal: this.signal }),
      window.liquidAjaxCart?.cart)
    )
      this.#i();
    else {
      const e = () => {
        (this.#i(), document.removeEventListener("liquid-ajax-cart:init", e));
      };
      document.addEventListener("liquid-ajax-cart:init", e, { signal: this.signal });
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  #s = (e) => {
    const t = e.target.closest("[data-ajax-cart-request-button]");
    t &&
      (this.#e && clearTimeout(this.#e),
      (this.#t = t),
      t.classList.add("is-removing-pending"),
      (this.#e = setTimeout(() => {
        this.#t === t && (t.classList.remove("is-removing-pending"), (this.#t = null));
      }, 500)));
  };
  #n = (e) => {
    const { requestState: t } = e.detail;
    this.#e && (clearTimeout(this.#e), (this.#e = null));
    const i = t.info?.initiator;
    if (
      (i?.hasAttribute("data-ajax-cart-request-button")
        ? ((this.#t = i), i.classList.remove("is-removing-pending"), i.classList.add("is-removing"))
        : this.#t &&
          (this.#t.classList.remove("is-removing-pending"), this.#t.classList.add("is-removing")),
      t.requestType !== "add")
    )
      return;
    (window.liquidAjaxCart?.cart?.item_count ?? 0) > 0 &&
      (this.open || this.showDialog(), (this.dataset.loading = ""));
  };
  #a = (e) => {
    const { requestState: t } = e.detail;
    (this.#t && (this.#t.classList.remove("is-removing", "is-removing-pending"), (this.#t = null)),
      t.requestType === "add" &&
        (delete this.dataset.loading, t.responseData?.ok && (this.open || this.showDialog())));
  };
  #o = (e) => {
    const t = e.detail?.resource;
    (this.#i(t), this.#r(t));
  };
  #r(e) {
    const t = (e?.item_count ?? 0) === 0;
    for (const i of this.querySelectorAll("[data-cart-static-footer], [data-cart-static-upsells]"))
      (!t && i.dataset.upsellsEmpty === "true") || (i.hidden = t);
  }
  #i(e) {
    const t = this.querySelector(".js-shipping-cost");
    if (!t) return;
    const i = parseInt(t.dataset.threshold) || 5e3,
      a = parseInt(t.dataset.standardCost) || 495;
    let n = 0;
    typeof e?.total_price == "number"
      ? (n = e.total_price)
      : typeof window.liquidAjaxCart?.cart?.total_price == "number" &&
        (n = window.liquidAjaxCart.cart.total_price);
    const r = this.dataset.locale || "de-DE",
      l = this.dataset.currency || "EUR",
      c = n >= i;
    if (c) {
      const s = t.dataset.freeShippingText || "Free shipping",
        o = document.createElement("span");
      ((o.className = "text-success font-semibold"), (o.textContent = s), t.replaceChildren(o));
    } else {
      const s = document.createElement("span");
      ((s.textContent = u(a, { locale: r, currency: l })), t.replaceChildren(s));
    }
    const d = this.querySelector(".js-cart-total");
    if (d) {
      const s = n + (c ? 0 : a);
      d.textContent = u(s, { locale: r, currency: l });
    }
  }
}
p("cart-drawer-component", f);
